import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyRequisites } from '../../../services/api/requisites';
import { LanguageService } from '../../../services/i18n/language';

@Component({
  selector: 'app-view-requisites',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-requisites.component.html',
  styleUrl: './view-requisites.component.scss'
})
export class ViewRequisitesComponent {
  @Input() requisites: CompanyRequisites | null = null;
  @Input() loading = false;
  @Input() error: string | null = null;
  /** Наименование компании — последней строкой (если передано). */
  @Input() companyName = '';

  // Translations
  basicInfoText = 'Основная информация';
  bankingInfoText = 'Банковская информация';
  binText = 'ИИН/БИН';
  legalAddressText = 'Юридический адрес';
  bankNameText = 'Банк';
  bikText = 'БИК';
  bankAccountsText = 'Счета в банке';
  contractSignerText = 'Подписант договора';
  signerPositionText = 'Должность';
  signerNameText = 'ФИО';
  loadingText = 'Загрузка...';
  noRequisitesText = 'Реквизиты не заполнены';

  constructor(private languageService: LanguageService) {
    this.updateTranslations();
    this.languageService.getTranslations().subscribe(() => {
      this.updateTranslations();
    });
  }

  private updateTranslations(): void {
    this.basicInfoText = this.languageService.translate('profile.legalDetails.basicInfo') || 'Основная информация';
    this.bankingInfoText = this.languageService.translate('profile.legalDetails.bankingInfo') || 'Банковская информация';
    this.binText = this.languageService.translate('profile.legalDetails.bin') || 'ИИН/БИН';
    this.legalAddressText = this.languageService.translate('profile.legalDetails.legalAddress') || 'Юридический адрес';
    this.bankNameText = this.languageService.translate('profile.legalDetails.bankName') || 'Банк';
    this.bikText = this.languageService.translate('profile.legalDetails.bik') || 'БИК';
    this.bankAccountsText = this.languageService.translate('profile.legalDetails.bankAccounts') || 'Счета в банке';
    this.contractSignerText = this.languageService.translate('profile.legalDetails.contractSigner') || 'Подписант договора';
    this.signerPositionText = this.languageService.translate('profile.legalDetails.signerPosition') || 'Должность';
    this.signerNameText = this.languageService.translate('profile.legalDetails.signerName') || 'ФИО';
    this.loadingText = this.languageService.translate('profile.loading') || 'Загрузка...';
    this.noRequisitesText = this.languageService.translate('profile.legalDetails.noRequisites') || 'Реквизиты не заполнены';
  }

  t(key: string, fallback: string): string {
    const value = this.languageService.translate(key);
    return value && value !== key ? value : fallback;
  }
}
